module.exports = __webpack_public_path__ + "img/1960.d01fadcc.svg";